<template>
  <header class="top-bar" v-if="$route.fullPath !== '/'" style="z-index:2">
    <div>
      <span>
        <img style="float:left;" class="logo" src="../assets/Nasta.png">
      </span>
    </div>
    <div class="title">
      <span>INSIDE INSIGHT</span>
    </div>
    <div style="margin-left:60%;">
      <el-tooltip class="item" effect="light" content="Instructions" placement="top">
        <img  class="admin" src="../assets/menu-button.png" @click="changeRoute('dashboard')">
      </el-tooltip>
    </div>
    <div>
      <el-tooltip class="item" effect="light" content="Welcome Mail" placement="top">
        <img  class="admin" src="../assets/contact.png" @click="changeRoute('send mail')">
      </el-tooltip>
    </div>
    <div >
      <el-dropdown  :hide-on-click="false" @command="handleSelect($event)">
      <span>
        <img  class="admin" src="../assets/admin.svg">
      </span>
        <el-dropdown-menu style="" slot="dropdown">
          <div style="padding: 10px;">
            <div style="position: absolute;width:5rem; height: 5rem; top: 2rem;">
              <el-button class="admin_name_btn">A</el-button>
            </div>
            <div style="position: relative; left: 5rem; width: 20rem;">
              <p>Admin</p>
              <p class="wo">admin@impactanalytics.co</p>
            </div>
          </div>
          <hr>
          <div align="right">
            <el-button style="margin: 5px;" @click="handleSelect()">Logout</el-button>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </header>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      Admin_Email: '',
      activeIndex: '1'
    }
  },
  methods: {
    ...mapActions({
      Logout: 'auth/Logout'
    }),
    handleSelect (event) {
      this.Logout(null)
      localStorage.removeItem('hashed-entities')
      this.$router.push('/')
    },
    changeRoute (data) {
      if (data === 'dashboard') {
        this.$router.push('/dashboard')
      } else {
        this.$router.push('/welcomemail')
      }
    }
  },
  watch: {
    Admin_Email (value) {
      console.log('Value', value)
    }
  }
}
</script>

<style>
.wo {
  max-width: 15rem;
  word-wrap: break-word;
}
.top-bar {
  height: 4.5rem;
  width: 100%;
  padding: 10px;
  background-color: #1C2B36;
  box-shadow: 5px 0px 10px rgba(0, 0, 0, 0.5);
  position: fixed;
  display: flex;
  top: 0px;
  z-index: 20;
}
.logo1 {
  width: 10%;
  /* text-align: center; */
  font-size: 20px;
  font-weight: bold;
  color: white;
  margin: 10px;
}
.title2 {
  font-size: 20px;
  color: white;
}
.admin {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/TopBar.vue